var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.activeAccount.iovation.items,"sort-by":"created","dense":"","sort-desc":"","calculate-widths":"","height":"405","loading":_vm.activeAccount.iovation.loading,"hide-default-footer":"","items-per-page":-1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }